import MaterialDialog, { DialogProps } from '@mui/material/Dialog';

export function Dialog(props: DialogProps) {
    return <MaterialDialog data-testid={'Dialog-container'} {...props} />;
}

export default Dialog;
